import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryNav() {
  const colorMap: Record<string, string> = {
    primary: 'bg-primary-100 text-primary-700 hover:bg-primary-200',
    accent: 'bg-accent-100 text-accent-900 hover:bg-accent-200',
    secondary: 'bg-secondary-100 text-secondary-900 hover:bg-secondary-200',
  };

  const iconColorMap: Record<string, string> = {
    primary: 'text-primary-500',
    accent: 'text-accent-500',
    secondary: 'text-secondary-500',
  };

  return (
    <section className="bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-8">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-1 h-6 bg-primary-500 rounded-full"></div>
          <h2 className="font-heading text-xl font-bold text-foreground-900">热门分类</h2>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className={`group flex items-center gap-3 p-4 rounded-xl transition-all duration-200 cursor-pointer ${
                colorMap[cat.color] || colorMap.primary
              }`}
            >
              <div className={`w-10 h-10 flex items-center justify-center rounded-lg bg-white/70 ${iconColorMap[cat.color] || iconColorMap.primary}`}>
                <i className={`${cat.icon} text-lg`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-semibold whitespace-nowrap">{cat.name}</h3>
                <p className="text-xs opacity-70 mt-0.5 line-clamp-1">{cat.description}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}